import type { FC } from 'react'

import type { SingleTicketDto } from '@hcr/api/consumer'

import { useTranslationsQuery } from '../../../hooks'
import { createSingleTicketNameString } from '../../../utils'

interface TranslationServiceNameProps {
  ticket: Pick<SingleTicketDto, 'category_id' | 'timeslot'>
}

export const TranslationServiceName: FC<TranslationServiceNameProps> = ({ ticket }) => {
  const { data, isError } = useTranslationsQuery({ categoryId: ticket.category_id })

  if (isError) {
    return createSingleTicketNameString({ category_id: ticket.category_id, timeslot: ticket.timeslot })
  }

  return createSingleTicketNameString({
    name: data?.translation,
    category_id: ticket.category_id,
    timeslot: ticket.timeslot,
  })
}
